import { Card, Flex } from 'antd';

const LargeCard = ({ title, description, mediaItemUrl, altText }) => {
	return (
		<>
			<Card className='LargeCard'>
				<Flex justify="center">
					<img
						loading="lazy"
						style={{
							width: '241px',
							height: '241px',
						}}
						src={mediaItemUrl} alt={altText}
					/>
				</Flex>
				<Flex justify="left" className='LargeCard-title'>
					<span className='s2-subtitle-800'>{title}</span>
				</Flex>
				<Flex justify="center">
					<div
						style={{
							height: '180px'
						}}
						className='b4-body-400'
						dangerouslySetInnerHTML={{ __html: description }}
					/>
				</Flex>
			</Card>
		</>
	)
}

export default LargeCard